<script setup lang="ts">
import VHelpTooltip from "../HelpTooltip/VHelpTooltip.vue";

defineOptions({
  name: "VSectionHeading",
});

/**
 * The heading of a list section on the App Store boards: a 17px bold title with an optional help question mark after
 * it. Controls in `actions` sit on the right of the same row.
 */
const {
  title,
  help = "",
  id = undefined,
  level = 2,
} = defineProps<{
  title: string
  /** Help text behind a question mark after the title; never a line next to or under it. */
  help?: string
  /** Id of the heading, for the `aria-labelledby` of its section. */
  id?: string
  level?: 2 | 3
}>();

defineSlots<{
  /** Rich content after the title on the same baseline, e.g. an info button. */
  default?: () => unknown
  actions?: () => unknown
}>();
</script>

<template>
  <div class="flex flex-wrap items-center gap-x-3 gap-y-2">
    <div class="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-2.5 gap-y-1">
      <component :is="`h${level}`" :id="id" class="m-0 text-[17px] font-bold text-(--text)">
        {{ title }}
      </component>
      <VHelpTooltip v-if="help" class="self-center" :content="help" :subject="title" />
      <slot />
    </div>
    <div v-if="$slots.actions" class="ml-auto flex flex-wrap items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>
